export default {
  'zh': '中文',
  'en': '英语'
};
